import React from "react";

export default function CarCompanySelector({
  companies,
  selectedCompanyCode,
  onSelectCompany,
}) {
  if (!companies || companies.length === 0) {
    return (
      <div className="car-insurance__company-block">
        <h3 className="car-insurance__group-sub-title">Công ty bảo hiểm</h3>
        <p className="car-insurance__empty-text">Đang tải danh sách công ty bảo hiểm...</p>
      </div>
    );
  }

  return (
    <div className="car-insurance__company-block">
      <h3 className="car-insurance__group-sub-title">Chọn công ty bảo hiểm</h3>
      <div className="car-insurance__company-grid" role="radiogroup" aria-label="Chọn công ty bảo hiểm">
        {companies.map((comp) => {
          const active = comp.code === selectedCompanyCode || comp.id === selectedCompanyCode;
          const code = String(comp.code || comp.id || "CÔNG TY").toUpperCase();
          const name = comp.name || comp.fullName || code;
          const logo = comp.image || comp.logo;

          return (
            <button
              key={comp.id || comp.code}
              type="button"
              role="radio"
              aria-checked={active}
              className={`car-insurance__company-card${active ? " car-insurance__company-card--active" : ""}`}
              onClick={() => onSelectCompany(comp)}
            >
              {/* Header row: Logo + Code */}
              <div className="car-insurance__company-card-header">
                <div className="car-insurance__company-card-logo-wrap">
                  {logo ? (
                    <img className="car-insurance__company-card-logo" src={logo} alt={code} />
                  ) : (
                    <span className="car-insurance__company-card-logo-fallback" aria-hidden>
                      {code.slice(0, 3)}
                    </span>
                  )}
                </div>
                <div className="car-insurance__company-card-code">{code}</div>
              </div>

              {/* Company Name on new line */}
              <div className="car-insurance__company-card-name" title={name}>
                {name}
              </div>

              {/* Active check badge */}
              {active ? (
                <div className="car-insurance__company-card-check">
                  <span>✓</span>
                </div>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
